module.exports = __webpack_public_path__ + "static/media/refresh-page-option.b11dac59.svg";